import { render, staticRenderFns } from "./AccordionSection.vue?vue&type=template&id=27eb0e53&scoped=true"
import script from "./AccordionSection.vue?vue&type=script&lang=ts"
export * from "./AccordionSection.vue?vue&type=script&lang=ts"
import style0 from "./AccordionSection.vue?vue&type=style&index=0&id=27eb0e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb0e53",
  null
  
)

export default component.exports